import { render, staticRenderFns } from "./FundTransfer.vue?vue&type=template&id=3bc762ea"
import script from "./FundTransfer.vue?vue&type=script&lang=js"
export * from "./FundTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports